import { Submenu } from "./submenu"
import React, { useRef, Fragment } from "react"
import posed from "react-pose"
import cx from "classnames"
import { useOvermind } from "../overmind"

export const Second = () => {
  const { state, actions } = useOvermind()
  const SecondElement = posed.div({
    closed: {
      opacity: 0,
      x: () => {
        return window.matchMedia("(max-width: 992px)").matches ? "100vw" : 0
      },
      zIndex: 0,
      transition: { ease: "linear", duration: 600 }
    },
    open: {
      opacity: 1,
      x: () => {
        return window.matchMedia("(max-width: 992px)").matches ? "15vw" : 0
      },
      zIndex: 100,
      transition: { ease: "linear", duration: 600 }
    },
    initialPose: "closed"
  })

  return (
    <SecondElement
      key="second"
      className="menuPanel2"
      initialPose="closed"
      withParent={false}
      pose={state.menu.isVisibleSecondPanel ? "open" : "closed"}>
      <div
        className="menuBack"
        onClick={() => {
          actions.menu.setSecondPanelHidden()
        }}>
        Назад
      </div>

      <Submenu />
    </SecondElement>
  )
}

{
  /* <div className="menuColumn">
  <ul className="menuSubmenu">
    <div className="menuColumn">
          <ul className="menuSubmenu">
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Mastersizer</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Zetasizer</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Kinexus</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">NanoSight</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Omnisec</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Archimedes</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Insitec</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Morphologi</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Spraytec</a>
            </MenuElement>
          </ul>
        </div>
        <div className="menuColumn">
          <ul className="menuSubmenu">
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Viscosizer</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">DSR</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Rosand</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Viscotec</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Parsum</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Microcal DSC</a>
            </MenuElement>
            <MenuElement className="menuSubmenuElement" initialPose="closed">
              <a href="#">Microcal ITC</a>
            </MenuElement>
          </ul>
          <h2>Пищевая промышленность</h2>
          <ul className="menuAdditionally">
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Кофе</a>
            </MenuElement>
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Пищевые добавки</a>
            </MenuElement>
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Пасты и&nbsp;соусы</a>
            </MenuElement>
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Шоколад</a>
            </MenuElement>
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Напитки</a>
            </MenuElement>
            <MenuElement className="menuAdditionallyElement">
              <a href="#">Сухие ингредиенты</a>
            </MenuElement>
          </ul>
        </div>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Zetasizer</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Kinexus</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">NanoSight</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Omnisec</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Archimedes</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Insitec</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Morphologi</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Spraytec</a>
    </MenuElement>
  </ul>
</div>
<div className="menuColumn">
  <ul className="menuSubmenu">
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Viscosizer</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">DSR</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Rosand</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Viscotec</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Parsum</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Microcal DSC</a>
    </MenuElement>
    <MenuElement className="menuSubmenuElement" initialPose="closed">
      <a href="#">Microcal ITC</a>
    </MenuElement>
  </ul>
  <h2>Пищевая промышленность</h2>
  <ul className="menuAdditionally">
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Кофе</a>
    </MenuElement>
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Пищевые добавки</a>
    </MenuElement>
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Пасты и&nbsp;соусы</a>
    </MenuElement>
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Шоколад</a>
    </MenuElement>
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Напитки</a>
    </MenuElement>
    <MenuElement className="menuAdditionallyElement">
      <a href="#">Сухие ингредиенты</a>
    </MenuElement>
  </ul>
</div> */
}
